import { camelize } from "inflected";
import { FrameworkPackageName } from "./FrameworkPackageName";
import { combineNamespacesAndApiIdentifier } from "./naming/APIElementNamer";

export const actionContextTypeName = (
  options:
    | {
        actionApiIdentifier: string;
        actionNamespace: string[];
        isGlobalAction: true;
      }
    | {
        actionApiIdentifier: string;
        modelApiIdentifier: string;
        modelNamespace: string[];
        isGlobalAction?: false;
      }
) => {
  if (options.isGlobalAction) {
    const actionName = combineNamespacesAndApiIdentifier(options.actionNamespace, options.actionApiIdentifier);
    return `${camelize(actionName)}GlobalActionContext`;
  } else {
    const actionName = options.actionApiIdentifier;
    const modelName = combineNamespacesAndApiIdentifier(options.modelNamespace, options.modelApiIdentifier);
    return `${camelize(actionName)}${camelize(modelName)}ActionContext`;
  }
};

export const effectValidationContextTypeName = (modelApiIdentifier: string, fieldApiIdentifier: string) => {
  return `${camelize(modelApiIdentifier)}${camelize(fieldApiIdentifier)}FieldValidationContext`;
};
